import { useState, useEffect, useRef } from 'react';

const FilterableSelect = (props) => {
  const [filter, setFilter] = useState(props.value || '');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(props.options);
  const [selectedOption, setSelectedOption] = useState(props.value || '');
  const inputRef = useRef(null);

  // Keep in sync if the parent's value changes externally (e.g. data loads after mount)
  useEffect(() => {
    setFilter(props.value || '');
    setSelectedOption(props.value || '');
  }, [props.value]);

  // Update filtered options whenever the filter changes
  useEffect(() => {
    setFilteredOptions(
      props.options && props.options.filter(option =>
        option?.toLowerCase().includes(filter?.toLowerCase())
      )
    );
  }, [filter, props.options]);

  const handleInputChange = (event) => {
    setFilter(event.target.value);
    setIsDropdownVisible(true); // Show the dropdown while typing
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option.target.value);
    setFilter(option.target.value);
    setIsDropdownVisible(false); // Hide dropdown after selection
    if (props.onChange) {
        props.onChange(option); // Trigger callback
    }
  };

  const handleInputFocus = () => {
    if (!props.disabled) {
      setIsDropdownVisible(true);
    }
  };

  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setIsDropdownVisible(false); // Hide dropdown when clicking outside
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={inputRef}
      className='w-full'
      style={{
        position: 'relative',
      }}
    >
      {/* Input Field */}
      <input
        type="text"
        value={filter}
        disabled={props.disabled}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        placeholder={props.placeholder || 'Type to filter options...'}
        style={{
          width: '100%',
          padding: '8px',
          fontSize: '14px',
          borderRadius: '4px',
          border: '1px solid #ccc',
        }}
      />

      {/* Dropdown */}
      {isDropdownVisible && (
        <ul
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '4px',
            maxHeight: '150px',
            overflowY: 'auto',
            zIndex: 10,
            margin: 0,
            padding: 0,
            listStyle: 'none',
          }}
        >
          {filteredOptions && filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <li
                key={index}
                onClick={() => handleOptionClick({target:{name: props.name, value: option}})}
                style={{
                  padding: '8px',
                  cursor: 'pointer',
                  backgroundColor:
                    option === selectedOption ? '#f0f0f0' : 'white',
                }}
              >
                {option}
              </li>
            ))
          ) : (
            <li
              style={{
                padding: '8px',
                color: '#888',
              }}
            >
              No options found
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default FilterableSelect;